/**
 * @description 实例管理 instanceManage
 * @author 系统生成
 * @date 2018/9/20
 */

import Logic from '../logic-base'

const instanceManageBiz = new Logic()

instanceManageBiz.manageList = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.instanceManage.manageList,
    data: data
  })
}

instanceManageBiz.instanceList = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.instanceManage.instanceList,
    data: data
  })
}

instanceManageBiz.executeCommand = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.instanceManage.executeCommand,
    data: data
  })
}
/**
 * Created by huangzhijie on 2018/10/18.
 * 实例列表 - 获取版本列表
 * @param appName app名称
 * @returns {Promise}
 */
instanceManageBiz.getVersionList = function (appName) {
  const data = {
    pageSize: 5,
    perPageCount: 100,
    currPage: 1,
    appName: appName
  }
  return new Promise((resolve, reject) => {
    this.ajax({
      ...this.REQUEST_OPT.programPackageManage.findRelease,
      data: data
    }).then((data) => {
      try {
        const res = {}
        data.dataList.map((item) => {
          res[item.version] = item.version
        })
        resolve(res)
      } catch (err) {
        reject(err)
      }
    })
  })
}

export default instanceManageBiz
